import { VoiceOption } from '../components/app/AIAgent/CustomizeVoiceAgentOptions'

const { REACT_APP_ELEVEN_LABS_API_READ_VOICES_KEY } = process.env
const ELEVEN_LABS_API_URL = 'https://api.elevenlabs.io/v2'

interface ElevenLabsVoice {
  voice_id: string
  name: string
  labels: {
    accent: string
    description?: string
    age: string
    gender: string
    use_case: string
  }
  preview_url: string
  description: string | null
}

interface ElevenLabsResponse {
  voices: ElevenLabsVoice[]
  has_more: boolean
  total_count: number
  next_page_token?: string
}

export const fetchVoices = async (): Promise<VoiceOption[]> => {
  const response = await fetch(
    `${ELEVEN_LABS_API_URL}/voices?include_total_count=true`,
    {
      headers: {
        'Xi-Api-Key': REACT_APP_ELEVEN_LABS_API_READ_VOICES_KEY || '',
      },
    },
  )

  if (!response.ok) {
    throw new Error('Failed to fetch voices')
  }

  const data: ElevenLabsResponse = await response.json()

  // Transform ElevenLabs voices to our VoiceOption format
  return data.voices.map(voice => ({
    id: voice.voice_id,
    name: voice.name,
    accent: voice.labels.accent as 'american' | 'british',
    previewUrl: voice.preview_url,
    labels: {
      description:
        voice.labels.description ||
        voice.description ||
        'No description available',
      age: voice.labels.age,
      gender: voice.labels.gender as 'male' | 'female',
      use_case: voice.labels.use_case,
    },
  }))
}
